import * as React from 'react';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';

// Utils
import { cond } from '@src/shared/src/util/general';
import { baseErrorCond } from '@toolkit/util/app';
// Constants
// Actions
import { hotelActions } from '@src/shared/src/actions';
// Models
// Interfaces
// Components
// Styles
import '../styles/HotelFavoriteButton.scss';

type Props = {
  hotelId: string;
  isFavorite: boolean;
};

const HotelFavoriteButton: React.FC<Props> = ({ hotelId, isFavorite }) => {
  const dispatch = useDispatch();
  const [isHotelFavorite, setIsHotelFavorite] = React.useState(isFavorite);

  const toggleFavorite = (e: React.MouseEvent) => {
    e.stopPropagation();

    setIsHotelFavorite(!isHotelFavorite);
    dispatch(
      hotelActions.setFavoriteHotelAsync.request({
        onError: (err) => {
          setIsHotelFavorite(isHotelFavorite); // Reset to previous state if error
          cond(baseErrorCond)(err);
        },
        isFavorite: !isHotelFavorite,
        hotelId,
      }),
    );
  };

  return (
    <button
      className={classNames('hotel-favorite-button', { 'is--active': isHotelFavorite })}
      onClick={(e) => toggleFavorite(e)}>
      <i className="material-symbols">favorite</i>
    </button>
  );
};

export default HotelFavoriteButton;
